import React, { useEffect } from "react";
import "./SavingCalculator.css";
import { savingCalculator } from "./calculatorContent.js";
import {
  Button,
  Typography,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  FormControlLabel,
  useMediaQuery,
} from "@mui/material";

import { useState } from "react";
import { inputStyle } from "./calculatorContent.js";
import { inputLabel } from "./calculatorContent.js";
import { outputLabel } from "./calculatorContent.js";
import { outputStyle } from "./calculatorContent.js";

const SavingCalculator = () => {
  // State for radio button
  const [select, setSelect] = useState("personal-loan");

  // State variables to hold the input values
  const [currentDebt, setCurrentDebt] = useState(50000);
  const [currentApr, setCurrentApr] = useState(18);
  const [newApr, setNewApr] = useState(15);
  const [transferFee, setTransferFee] = useState(3);
  const [repaymentPeriod, setRepaymentPeriod] = useState(19);

  // State variables for results
  const [totalSavings, setTotalSavings] = useState(0);
  const [monthlySavings, setMonthlySavings] = useState(0);
  const [netGain, setNetGain] = useState(0);

  // State to track if the "Calculate" button has been clicked
  const [isCalculated, setIsCalculated] = useState(false);

  // Function to format numbers as Indian currency
  const formatter = (value) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatCurrency = (value) => {
    return value.toLocaleString("en-IN");
  };

  const handleAmountChange = (e, setter) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    if (/^\d*\.?\d*$/.test(value)) {
      // Allow only numbers and a single decimal point
      setter(Number(value));
    }
  };
  // Function to calculate values when the "Calculate" button is clicked
  const handleCalculate = () => {
    const currentMonthlyRate = currentApr / 12 / 100;
    const newMonthlyRate = newApr / 12 / 100;

    // Monthly Payment Calculations
    const currentMonthlyPayment =
      (currentDebt * currentMonthlyRate) /
      (1 - Math.pow(1 + currentMonthlyRate, -repaymentPeriod));
    const newMonthlyPayment =
      (currentDebt * newMonthlyRate) /
      (1 - Math.pow(1 + newMonthlyRate, -repaymentPeriod));

    // Total Payment Calculations
    const totalPaymentCurrent = currentMonthlyPayment * repaymentPeriod;
    const totalPaymentNew = newMonthlyPayment * repaymentPeriod;

    // Total Interest Paid
    const totalInterestCurrent = totalPaymentCurrent - currentDebt;
    const totalInterestNew = totalPaymentNew - currentDebt;

    // Transfer Fee Amount
    const transferFeeAmount = (transferFee / 100) * currentDebt;

    // Savings Calculations
    const totalSavingsValue = totalInterestCurrent - totalInterestNew;
    const monthlySavingsValue = currentMonthlyPayment - newMonthlyPayment;
    const netGainValue = totalSavingsValue - transferFeeAmount;

    // Set results in state
    setTotalSavings(isNaN(totalSavingsValue) ? 0 : totalSavingsValue);
    setMonthlySavings(isNaN(monthlySavingsValue) ? 0 : monthlySavingsValue);
    setNetGain(isNaN(netGainValue) ? 0 : netGainValue);

    // Set the "isCalculated" flag to true to show the results
    setIsCalculated(true);
  };

  // Automatically calculate on input change if the user has clicked the Calculate button
  useEffect(() => {
    if (isCalculated) {
      handleCalculate();
    }
  }, [currentDebt, currentApr, newApr, transferFee, repaymentPeriod]);

  // handling visibility of need help container

  // handling radio button
  const handleRadioButton = (event) => {
    setSelect(event.target.value);
  };

  // useMediaQuary
  const isSmallScreen = useMediaQuery("(max-width: 576px)");
  const isMediumScreen = useMediaQuery(
    "(min-width: 577px) and (max-width: 1200px)"
  );
  const isLargeScreen = useMediaQuery("(min-width: 1201px)");

  return (
    <>
      <div className="saving_calculator  ">
        <div className="saving_calculator_content">
          <div className="">
            <div className="saving_calculator_header mb-3">
              <Typography
                sx={{
                  fontSize: {
                    xs: "22px",
                    sm: "24.4312px",
                    md: "30.2752px",
                    lg: "35.1927px",
                  },
                  fontWeight: 600,
                  fontFamily: "'Archivo',sans-serif",
                }}
                className="saving_calculator_title  "
              >
                {savingCalculator[0].title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "16px",
                  lineHeight: "24px",
                  letterSpacing: "normal",
                  textAlign: "start",
                  color: "#1F1F1F",
                }}
              >
                {savingCalculator[0].description}
              </Typography>
            </div>

            <div className="line"></div>

            <div className="saving_calculator_details mt-5">
              <div className="card_debt_heading">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "24px",
                    lineHeight: "28px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 700,
                  }}
                  className=""
                >
                  {savingCalculator[1].inputsHeadingOne}
                </Typography>
              </div>
              <div className="card_debt d-flex justify-content-between gap-3 mt-3 flex-column flex-md-row">
                <div className="new_card  w-100">
                  <label>
                    <Typography sx={inputLabel}>
                      Current Credit Card Debt (₹):
                    </Typography>
                  </label>

                  <FormControl fullWidth sx={inputStyle}>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      fullWidth
                      size="small"
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="archivo">&#8377;</span>
                        </InputAdornment>
                      }
                      value={formatCurrency(currentDebt)} // Display value with commas
                      onChange={(e) => handleAmountChange(e, setCurrentDebt)}
                    />
                  </FormControl>
                </div>
                <div className="current_card  w-100">
                  <label className="table_font">
                    <Typography sx={inputLabel}>
                      Current Interest Rate (APR %){" "}
                    </Typography>
                  </label>

                  <FormControl fullWidth sx={inputStyle}>
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      fullWidth
                      size="small"
                      endAdornment={
                        <InputAdornment position="start">
                          <span className="archivo">%</span>
                        </InputAdornment>
                      }
                      value={currentApr || 0}
                      onChange={(e) => {
                        let value = e.target.value.replace(/,/g, "");
                        if (/^\d*\.?\d*$/.test(value)) {
                          if (value === "") {
                            setCurrentApr("");
                          } else {
                            setCurrentApr(value.replace(/^0+/, "") || "0"); // Remove leading zero
                          }
                        }
                      }}
                      onFocus={() => currentApr === "0" && setCurrentApr("")} // Empty field on focus
                      onBlur={() =>
                        setCurrentApr(currentApr === "" ? "0" : currentApr)
                      }
                    />
                  </FormControl>
                </div>
              </div>
              {/* radio button */}
              <div className="radio_btn mt-5">
                <Typography sx={inputLabel}>
                  Transfer Loan Type:{" "}
                  <span
                    style={{ fontSize: "14px", color: "#8A8A8A" }}
                    className=""
                  >
                    (required)
                  </span>
                </Typography>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={select}
                    onChange={handleRadioButton}
                  >
                    <FormControlLabel
                      value="personal-loan"
                      control={<Radio />}
                      label="Personal Loan"
                    />
                    <FormControlLabel
                      value="credit-card"
                      control={<Radio />}
                      label="Credit Card"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className=" ">
                <div className="transfer_card_heading pt-3">
                  <p className="table_font">
                    {savingCalculator[1].inputsHeadingTwo}
                  </p>
                </div>
                <div className="transfer_card_inputs d-flex justify-content-between gap-3 mt-3 flex-column flex-md-row">
                  <div className="transfer_fee  w-100">
                    <label className="table_font fw-bold">
                      <Typography sx={inputLabel}>
                        Processing Fee (%):{" "}
                      </Typography>
                    </label>
                    <FormControl fullWidth sx={inputStyle}>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        endAdornment={
                          <InputAdornment position="start">
                            <span className="archivo">%</span>
                          </InputAdornment>
                        }
                        value={transferFee || 0}
                        onChange={(e) => {
                          let value = e.target.value.replace(/,/g, "");
                          if (/^\d*\.?\d*$/.test(value)) {
                            if (value === "") {
                              setTransferFee("");
                            } else {
                              setTransferFee(value.replace(/^0+/, "") || "0");
                            }
                          }
                        }}
                        onFocus={() =>
                          transferFee === "0" && setTransferFee("")
                        } // Empty field on focus
                        onBlur={() =>
                          setTransferFee(transferFee === "" ? "0" : transferFee)
                        }
                      />
                    </FormControl>
                  </div>
                  <div className="number_of_months  w-100">
                    <label className="table_font fw-bold">
                      <Typography sx={inputLabel}>
                        Repayment Period (Months):{" "}
                      </Typography>
                    </label>
                    <FormControl fullWidth sx={inputStyle}>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        // value={inputs.repaymentPeriod}
                        // onChange={handleChange}
                        value={repaymentPeriod}
                        onChange={(e) =>
                          handleAmountChange(e, setRepaymentPeriod)
                        }
                      />
                    </FormControl>
                  </div>
                </div>
                <div style={{ width: "49%" }} className="new_card mt-3  ">
                  <label>
                    <Typography sx={inputLabel}>
                      New Interest Rate (APR %):
                    </Typography>
                  </label>

                  <FormControl
                    style={{
                      width: isSmallScreen
                        ? "205%"
                        : isMediumScreen
                        ? "100%"
                        : isLargeScreen
                        ? "100%"
                        : "auto",
                    }}
                    sx={inputStyle}
                  >
                    <OutlinedInput
                      fullWidth
                      id="outlined-adornment-amount"
                      size="small"
                      endAdornment={
                        <InputAdornment position="start">
                          <span className="archivo">%</span>
                        </InputAdornment>
                      }
                      value={newApr || 0} // Display value with commas
                      onChange={(e) => {
                        let value = e.target.value.replace(/,/g, "");
                        if (/^\d*\.?\d*$/.test(value)) {
                          if (value === "") {
                            setNewApr("");
                          } else {
                            setNewApr(value.replace(/^0+/, "") || "0"); // Remove leading zero
                          }
                        }
                      }}
                      onFocus={() => newApr === "0" && setNewApr("")} // Empty field on focus
                      onBlur={() => setNewApr(newApr === "" ? "0" : newApr)}
                    />
                  </FormControl>
                </div>
              </div>
              <div className="mt-5">
                <Button
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    textTransform: "none",
                    fontSize: "16px",
                  }}
                  onClick={handleCalculate}
                  variant="contained"
                  color="secondary"
                >
                  Calculate
                </Button>
              </div>{" "}
            </div>
          </div>
          {/* Results data */}

          {isCalculated && (
            <div
              className="d-flex flex-column justify-content-between gap-4 w-100"
              style={{ marginTop: "20px" }}
            >
              <div className="months">
                <Typography sx={outputLabel}>Total Savings: </Typography>
                <Typography sx={outputStyle}>
                  {formatter(totalSavings)}
                </Typography>
              </div>
              <div className="months">
                <Typography sx={outputLabel}>Monthly Savings: </Typography>
                <Typography sx={outputStyle} className=" text-break">
                  {formatter(monthlySavings)}{" "}
                </Typography>
              </div>
              <div className="months">
                <Typography sx={outputLabel}>Net Gain: </Typography>
                <Typography sx={outputStyle} className=" text-break">
                  {formatter(netGain)}{" "}
                </Typography>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SavingCalculator;
